export default __webpack_public_path__ + "static/media/app-bar-login.88fb204d.svg";